import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "button-group mt-3" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PricingStrategyNameDaysComponent = _resolveComponent("PricingStrategyNameDaysComponent")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_ManageTimeWindowModal = _resolveComponent("ManageTimeWindowModal")!
  const _component_CopyDayModal = _resolveComponent("CopyDayModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: "row mb-3",
      style: _normalizeStyle({ opacity: _ctx.isCalendarVisible ? 1 : 0 })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.currentStrategy.isMultipleWindows)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_PricingStrategyNameDaysComponent, {
                  name: _ctx.windowProp.name,
                  description: _ctx.windowProp.description,
                  daysIn: _ctx.windowProp.daysIn,
                  daysOut: _ctx.windowProp.daysOut,
                  invalidDaysIn: _ctx.invalidDaysIn(_ctx.windowProp.id),
                  invalidDaysOut: _ctx.invalidDaysOut(_ctx.windowProp.id),
                  daysInMoreThanDayOut: _ctx.daysInMoreThanDayOut(_ctx.windowProp.id),
                  invalidName: _ctx.invalidName(_ctx.windowProp.id),
                  onUpdateWindow: _ctx.handleUpdateWindowProp
                }, null, 8, ["name", "description", "daysIn", "daysOut", "invalidDaysIn", "invalidDaysOut", "daysInMoreThanDayOut", "invalidName", "onUpdateWindow"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isCalendarVisible)
            ? (_openBlock(), _createBlock(_component_FullCalendar, {
                key: `calendar-${_ctx.windowIndex}-${_ctx.priceWindowId}`,
                options: _ctx.calendarOptions,
                "data-window-index": _ctx.windowIndex,
                ref: 
              (el) => {
                _ctx.fullCalendarRef = el;
              }
            
              }, null, 8, ["options", "data-window-index"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateTimeWindowModal && _ctx.openCreateTimeWindowModal(...args)))
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
              _createTextVNode(" Create New Time Window ", -1)
            ]))]),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCopyDayModal && _ctx.openCopyDayModal(...args)))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fa fa-copy" }, null, -1),
              _createTextVNode(" Copy Day ", -1)
            ]))])
          ])
        ])
      ]),
      _createVNode(_component_ManageTimeWindowModal, {
        calendarOptions: _ctx.calendarOptions,
        initialData: _ctx.initialDataForTimeManagement,
        operationType: _ctx.eventOperationType,
        manageTimeWindowModalRef: _ctx.manageTimeWindowModalRef,
        onManageTimeWindowResult: _ctx.handleManageTimeWindowResult,
        onSetModalRef: _cache[2] || (_cache[2] = ($event: any) => (_ctx.manageTimeWindowModalRef = $event)),
        utilizationPriceSettingsRef: _ctx.utilizationPriceSettingsRef,
        "onUpdate:utilizationPriceSettingsRef": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.utilizationPriceSettingsRef) = $event)),
        currentStrategy: _ctx.currentStrategy
      }, null, 8, ["calendarOptions", "initialData", "operationType", "manageTimeWindowModalRef", "onManageTimeWindowResult", "utilizationPriceSettingsRef", "currentStrategy"]),
      (_ctx.isCopyDayModalOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "copy-day-modal-backdrop",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeCopyDayModal && _ctx.closeCopyDayModal(...args)))
            }),
            _createVNode(_component_CopyDayModal, {
              initialData: _ctx.initialData,
              onCancel: _ctx.closeCopyDayModal,
              onCopy: _ctx.handleCopyDay
            }, null, 8, ["initialData", "onCancel", "onCopy"])
          ]))
        : _createCommentVNode("", true)
    ], 4),
    _createVNode(_component_ConfirmModal, {
      show: _ctx.showOverwriteConfirmModal,
      message: "Warning: Data Will Be Overwritten",
      prompt: "This action will permanently delete the existing data and replace it with the copied content. This cannot be undone. Do you want to continue?",
      confirmText: "Continue",
      cancelText: "Cancel",
      confirmType: "confirm-modal-btn-primary",
      cancelType: "confirm-modal-btn-danger",
      onConfirm: _ctx.onOverwriteConfirm
    }, null, 8, ["show", "onConfirm"])
  ], 32))
}